import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { translate } from '../../../../shared/translations';
import Button from '../../../../shared/components/Button/Button';
import TextInput from '../../../../shared/components/FormControls/TextInput/TextInput';
import { setActiveDialogAction, ssoLoginAction, standardLoginAction } from '../../../../actions/actionCreators';
import { getIdentityProviders, getStandardLoginErrors } from '../../../../selectors/login';
import { LOGIN_QUESTIONS, FORGOT_PASSWORD } from '../../../../constants/constants';
import { Paragraph2, Subhead1, ButtonText } from '../../../../shared/theme/styles';

export const StandardForm = ({ setSSO }) => {
    const dispatch = useDispatch();
    const [usernameValue, setUsernameValue] = useState('');
    const [passwordValue, setPasswordValue] = useState('');
    const loginErrors = useSelector(getStandardLoginErrors);
    const identityProviders = useSelector(getIdentityProviders);

    const onUsernameChange = ({ target: { value } }) => setUsernameValue(value);
    const onPasswordChange = ({ target: { value } }) => setPasswordValue(value);

    const onFormSubmit = (event) => {
        event.preventDefault();
        dispatch(standardLoginAction({ username: usernameValue, password: passwordValue }));
    };

    const onUseSSOClick = () => {
        if (identityProviders.length !== 0 && identityProviders.length > 1) {
            setSSO(true);
        } else {
            dispatch(ssoLoginAction(identityProviders[0]));
        }
    };

    const onForgotPasswordDialogOpen = () => {
        dispatch(setActiveDialogAction(FORGOT_PASSWORD));
    };

    const onLoginQuestionsDialogOpen = () => {
        dispatch(setActiveDialogAction(LOGIN_QUESTIONS));
    };

    return (
        <div className="loginFormPanel">
            <Form
                id="standardLoginForm"
                className="loginForm"
                onSubmit={onFormSubmit}
            >
                <div className="loginFormLabel" style={Subhead1}>
                    {translate('management_portal')}
                </div>
                {Object.keys(loginErrors).length !== 0 && (
                    <div className="text-danger errorMessage">
                        {translate('username_or_password_is_incorrect')}
                    </div>
                )}
                <TextInput
                    id="usernameInput"
                    className="textInput"
                    style={Paragraph2}
                    value={usernameValue}
                    onChange={onUsernameChange}
                    type="text"
                    placeholder={translate('username')}
                    isInvalid={Object.keys(loginErrors).length !== 0}
                />
                <TextInput
                    id="passwordInput"
                    className="textInput"
                    style={Paragraph2}
                    value={passwordValue}
                    onChange={onPasswordChange}
                    type="password"
                    placeholder={translate('password')}
                    isInvalid={Object.keys(loginErrors).length !== 0}
                />
                <div className="loginFormButtonGroup">
                    {
                        identityProviders.length > 0 && (
                            <div
                                id="useSSOButton"
                                className="hyperlink-label useSSOBtn"
                                style={ButtonText}
                                role="button"
                                tabIndex={0}
                                onClick={onUseSSOClick}
                            >
                                {translate('use_sso')}
                            </div>
                        )
                    }
                    <Button
                        id="standardLoginSubmitButton"
                        variant="primary"
                        type="submit"
                        content={translate('login')}
                    />
                </div>
            </Form>
            <div className="loginFormModallinks">
                <div
                    id="forgotPasswordModalButton"
                    className="hyperlink-label"
                    style={ButtonText}
                    role="button"
                    tabIndex={0}
                    onClick={onForgotPasswordDialogOpen}
                >
                    {translate('i_forgot_my_username_or_password')}
                </div>
                <div
                    id="loginQuestionsModalButton"
                    className="hyperlink-label"
                    style={ButtonText}
                    role="button"
                    tabIndex={0}
                    onClick={onLoginQuestionsDialogOpen}
                >
                    {translate('i_dont_know_which_login_to_use')}
                </div>
            </div>
        </div>
    );
};

export default StandardForm;
